import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { useParams } from "react-router-dom";
import {
  clearAdminItemById,
  getAdminEwgDataById,
  updateAdminEwgDataById,
} from "../../store/slices/ewg";
import { setDataLoading } from "../../store/slices/admin";
import {
  AdminContentWrapper,
  AdminDetailInfoItem,
  AdminDetailPageHeader,
  Button,
} from "../../components";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import AdminEwgDetailInfoItem from "./adminEwgDetailInfoItem";
import transformHexToRgba from "../../util/transformHexToRgba";
import appConfig from "../../util/appConfig";
import { ewgStatuses } from "../AdminEwg";
import style from "./style.module.scss";
import { add } from "lodash";

const AdminEwgById = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { isEwgDataLoading, ewgItemInfo } = useAppSelector(
    (state) => state.ewg.admin,
  );

  useEffect(() => {
    if (id) {
      dispatch(getAdminEwgDataById(id));
    }
    return () => {
      dispatch(clearAdminItemById());
      dispatch(setDataLoading(false));
    };
  }, []);

  const items = [
    {
      title: "Detailinformation",
      items: [
        {
          rowTitle: "Status",
          rowInfo: ewgStatuses[ewgItemInfo?.status!],
        },
        {
          rowTitle: "Erstelungsdatum",
          rowInfo: ewgItemInfo
            ? format(new Date(ewgItemInfo?.createdAt), "dd.MM.yyyy", {
                locale: de,
              })
            : "",
        },
        {
          rowTitle: "Aktenzeichen",
          rowInfo: ewgItemInfo?.aktenzeichen.toString() || "",
        },
        {
          rowTitle: "Objekt ID",
          rowInfo: ewgItemInfo?.idNumber.toString() || "",
        },
        {
          rowTitle: "Nachricht",
          rowInfo: ewgItemInfo?.additionalComment ?? "",
        },
      ],
    },
    {
      title: "Kontaktdaten",
      items: [
        {
          rowTitle: "EMail",
          rowInfo: `${ewgItemInfo?.email}`,
        },
        {
          rowTitle: "Telefonnummer",
          rowInfo: `${
            ewgItemInfo?.phoneNumber ? ewgItemInfo?.phoneNumber : "-"
          }`,
        },
      ],
    },
  ];

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <AdminDetailPageHeader isBtnAvailable={false} />
      <AdminContentWrapper>
        {isEwgDataLoading ? null : !ewgItemInfo ? null : (
          <>
            <div>
              {items.map((el, idx) => {
                return (
                  <AdminDetailInfoItem
                    items={el.items}
                    title={el.title}
                    key={idx}
                  />
                );
              })}
              {ewgItemInfo.einwohnergleichwertabfrageItems?.reduce(
                (prev, curr) => {
                  if (prev) return prev;
                  if (!curr.isQuantityPlausible) {
                    prev = true;
                  }

                  return prev;
                },
                false,
              ) ? (
                <div
                  style={{
                    marginBottom: "40px",
                  }}
                >
                  <div className={style.title}>Plausibilität</div>
                  <div
                    className={style.tableInfoWrapper}
                    style={{
                      borderBottom: ewgItemInfo.einwohnergleichwertabfrageItems
                        .length
                        ? "none"
                        : "",
                    }}
                  >
                    <div
                      className={style.rowWrapper}
                      style={{
                        borderBottom: !ewgItemInfo
                          .einwohnergleichwertabfrageItems.length
                          ? "none"
                          : "",
                      }}
                    >
                      <div
                        className={style.rowTitle}
                        style={{
                          minWidth: "calc(100% / 3)",
                        }}
                      >
                        Erfasster Unternehmensname
                      </div>
                      <div
                        className={style.rowTitle}
                        style={{
                          minWidth: "calc(100% / 3)",
                        }}
                      >
                        Summe der Beschäftigten
                      </div>
                      <div
                        className={style.rowTitle}
                        style={{
                          borderRight: "none",
                          minWidth: "calc(100% / 3)",
                        }}
                      >
                        Plausibilität
                      </div>
                    </div>
                    {ewgItemInfo.einwohnergleichwertabfrageItems?.map(
                      (el, idx) => {
                        if (el.isQuantityPlausible) {
                          return null;
                        }

                        const isEmployee = el.typeSpace === "Beschäftigte";

                        return (
                          <>
                            {!el.isQuantityPlausible ? (
                              <div className={style.rowWrapper} key={idx}>
                                <div
                                  className={style.rowInfo}
                                  style={{
                                    minWidth: "calc(100% / 3)",
                                  }}
                                >
                                  {el.companyName}
                                </div>
                                <div
                                  className={style.rowInfo}
                                  style={{
                                    minWidth: "calc(100% / 3)",
                                  }}
                                >
                                  {!isEmployee
                                    ? +el.quantity
                                    : add(
                                        +el.quantity,
                                        add(
                                          +el.quantityOfHalfDayEymployees,
                                          +el.quantityOfPartTimeEmployees,
                                        ),
                                      )}
                                </div>
                                <div
                                  className={style.rowInfo}
                                  style={{
                                    minWidth: "calc(100% / 3)",
                                  }}
                                >
                                  {el.quantityExceeded === "above"
                                    ? "Maximum Grenze überschritten"
                                    : "Minimum Grenze unterschritten"}
                                </div>
                              </div>
                            ) : null}
                          </>
                        );
                      },
                    )}
                  </div>
                </div>
              ) : null}
              <AdminEwgDetailInfoItem
                title="Einwohnergleichwert"
                items={ewgItemInfo.einwohnergleichwertabfrageItems}
              />
            </div>
            <div
              style={{
                // textAlign: "end",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "30px",
                alignSelf: "flex-end",
              }}
            >
              <Button
                text="Stornieren"
                width="200"
                type="button"
                backgroundColor="white"
                isOutlined
                outlineColor={
                  ewgItemInfo?.status === "declined"
                    ? transformHexToRgba("#ff0000", "0.4")
                    : "red"
                }
                textColor={
                  ewgItemInfo?.status === "declined"
                    ? transformHexToRgba("#ff0000", "0.4")
                    : "red"
                }
                onClick={() => {
                  if (id) {
                    dispatch(
                      updateAdminEwgDataById({
                        id,
                        status: "declined",
                      }),
                    );
                  }
                }}
                disabled={ewgItemInfo?.status === "declined"}
              />
              <Button
                text="Akzeptieren"
                width="200"
                backgroundColor={
                  ewgItemInfo?.status === "accepted"
                    ? transformHexToRgba(appConfig.mainColor, "0.4")
                    : appConfig.mainColor
                }
                marginRight="20"
                onClick={() => {
                  if (id) {
                    dispatch(
                      updateAdminEwgDataById({
                        id,
                        status: "accepted",
                      }),
                    );
                  }
                }}
                disabled={ewgItemInfo?.status === "accepted"}
              />
            </div>
          </>
        )}
      </AdminContentWrapper>
    </div>
  );
};

export default AdminEwgById;
